import { render, staticRenderFns } from "./dev-param-form10.vue?vue&type=template&id=c45eb46c&scoped=true&"
import script from "./dev-param-form10.vue?vue&type=script&lang=js&"
export * from "./dev-param-form10.vue?vue&type=script&lang=js&"
import style0 from "./dev-param-form10.vue?vue&type=style&index=0&id=c45eb46c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45eb46c",
  null
  
)

export default component.exports